import { AreaEnum, AreaLeavesDto } from 'src/types/area';

export const AREA_MOSCOW = { id: '1', text: 'Москва' } as const;
export const AREA_SBP = { id: '2', text: 'Санкт-Петербург' } as const;
export const AREA_RUSSIA = { id: '113', text: 'Вся Россия' } as const;

export const TOP_AREAS: AreaLeavesDto[] = [
    AREA_MOSCOW,
    AREA_SBP,
    {
        id: '3',
        text: 'Екатеринбург',
    },
    {
        id: '88',
        text: 'Казань',
    },
    {
        id: '66',
        text: 'Нижний Новгород',
    },
    {
        id: '104',
        text: 'Челябинск',
    },
    {
        id: '54',
        text: 'Красноярск',
    },
    {
        id: '78',
        text: 'Самара',
    },
    {
        id: '99',
        text: 'Уфа',
    },
];

export const PROFESSION_AREAS = [AREA_MOSCOW, AREA_SBP, AREA_RUSSIA] as const;

// Для аналитики
export const professionAreaIdToAreaEnumMap: Record<string, AreaEnum> = {
    [AREA_MOSCOW.id]: AreaEnum.MSK,
    [AREA_SBP.id]: AreaEnum.SPB,
    [AREA_RUSSIA.id]: AreaEnum.ALL,
};
